import {
    useHistory,
    useLocation
} from 'react-router-dom/cjs/react-router-dom.min';
import { winnreAuth } from '../../utils/axios';

import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../store/auth-slice';
const useData = () => {
    
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const scParam = queryParams.get('sc');
    const EventName = queryParams.get('eventName');
    const EventTime= queryParams.get('eventTime');
    const ResponseID= queryParams.get('responseId');


    const history = useHistory();
    const dispatch = useDispatch();
    const [userScratchcard, setUserScratchcard] = useState([]);
    const [loadingSC, setLoadingSC] = useState(false);
    const [rewardData, setRewardData] = useState();
    const [openScratchCard, setOpenScratchCard] = useState(
        !!scParam ? 'TRIGGER' : 'CLOSE'
    );

    const userHash = useSelector((state) => state.auth.userHash);
    const userRole = useSelector((state) => state.auth.userRole);

    const clientWebview = useSelector((state) => state.webView.clientWebview);
    const internalWebview = useSelector(
        (state) => state.webView.internalWebview
    );
    const clickThroughMobile = clientWebview || internalWebview;
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const redirectUrl = useSelector((state) => state.auth.redirectUrl);

    const generateScratchCard = () => {
        if (userRole === 'RELATIONSHIP_MANAGER' || userRole === 'EMPLOYEE') {
            return;
        }

        const uniqueId = EventTime || ResponseID;

        winnreAuth({
            method: 'post',
            // url: `/winnre/user/scratchCard/generate?eventName=${EventName}`
               url : `/winnre/user/scratchCard/generate-v2?eventName=${EventName}&uniqueId=${uniqueId}`
        })
            .then((item) => {
                console.log('sc under Reward', item);

                if (item?.status === 'FAILED') {
                    // console.log('No more Assigned deals');
                    return;
                }
                if (item?.status !== 'ASSIGNED') {
                    toast.info(`You have already ${item?.status.toLowerCase()} your scratch card.Please check the rewards section for details.`);
                    history.replace({
                        pathname: location.pathname
                    });
                    return; 
                }
                setOpenScratchCard('OPEN');
                const deal = item.deal;
                const sc = {
                    dealId: deal?.id,
                    status: item?.status,
                    expiryDate: item?.expiry,
                    scratchCardId: item?.id,
                    title: deal?.title,
                    description: deal?.description,
                    redemptionType: deal?.redemptionType,
                    endDate: deal?.endDate,
                    eligibleCashback: deal?.eligibleCashback,
                    category: deal?.category?.name,
                    tags: deal?.tags?.map((tag) => tag?.name),
                    redemptionCode: deal?.dealRedemptionCode?.dealCode,
                    redeemLink: deal?.dealRedemptionCode?.voucherCodeLink,
                    logoUrl: deal?.vendor?.logo?.url,
                    vendorName: deal?.vendor?.name,
                    url: deal?.url
                };
                // console.log("sc" , sc);
                setRewardData(sc);
                window?.webengage?.track('ScratchCardGenerated', {
                    responseID: `${ResponseID}`, // Pass the responseID here
                });
                // console.log('rewardData', item);
                history.replace({
                    pathname: location.pathname
                });
               
                
            })
            .catch((err) => {
                // console.log(err);
                toast.error('Something went wrong. Please try again');
            });
    };

    const getUserScratchcards = () => {
        setLoadingSC(true);
        winnreAuth({
            method: 'GET',
            url: `/winnre/user/scratchCard/getAllForUser?userHash=${userHash}`
        })
            .then((res) => {
                setLoadingSC(false);
                console.log('getAll', res);
                if (res?.status === 'APIErrorCondition') {
                    toast.error(res?.message);
                    setUserScratchcard([]);
                    return;
                } else {
                    setUserScratchcard(
                        res?.content.map((item) => {
                            const deal = item?.deal;
                            return {
                                dealId: deal?.id,
                                status: item?.status,
                                expiryDate: item?.expiry,
                                scratchCardId: item?.id,
                                title: deal?.title,
                                description: deal?.description,
                                redemptionType: deal?.redemptionType,
                                endDate: deal?.endDate,
                                eligibleCashback: deal?.eligibleCashback,
                                category: deal?.category?.name,
                                tags: deal?.tags?.map((tag) => tag?.name),
                                redemptionCode:
                                    deal?.dealRedemptionCode?.dealCode,
                                redeemLink:
                                    deal?.dealRedemptionCode?.voucherCodeLink,
                                logoUrl: deal?.vendor?.logo?.url,
                                vendorName: deal?.vendor?.name,
                                url: deal?.url
                            };
                        })

                    );
                }
               
            })
            .catch((err) => {
                // console.log(err);
            });
    };

    

    const updateScratchCardStatus = (id, status, silentUpdate) => {
        winnreAuth({
            method: 'post',
            url: `/winnre/user/scratchCard/updateStatus?id=${id}&status=${status}`
        })
            .then((res) => {
                console.log('Update Status Response:', res);
                if (res.status === 'FAILED') {
                    toast.error('Failed to update status. Please try again');
                } else if (silentUpdate) {
                    return;
                } else {
                    getUserScratchcards();
                }
            })
            .catch((err) => {
                // console.log(err);
                toast.error('Something went wrong. Please try again');
            });
    };
    const rewardRedeemHandler = (data, isReward) => {
        winnreAuth({
            method: 'post',
            url: `winnre/user/deals/redeem-v2?dealId=${
                data.dealId
            }&sourcePlatform=${clickThroughMobile ? 'MOBILE' : 'WEBSITE'}`
        })
            .then((res) => {
                console.log('reward', res);

                if (isReward) {
                    window?.webengage?.track('DealClicked', {
                        OfferName: `${data?.deal?.title}}`,
                        RedemptionType: `${data?.deal?.redemptionType}`,
                        CashbackPercentage: `${data?.deal?.eligibleCashback}`,
                        CouponCode: `${data?.deal?.dealRedemptionCode?.dealCode}`,
                        Category: `${data?.deal?.category?.name}`,
                        Vendor: `${data?.deal?.vendor?.name}`,
                        Link: `${data?.deal?.url}`,
                        EndDate: `${data?.deal?.endDate}`,
                        Tags: `${data?.deal?.tags?.map((tag) => tag?.name)}`,
                        DealId: `${data?.dealId}`,
                        VoucherCode:
                            data?.deal?.redemptionType === 'VOUCHER' &&
                            res?.status == 'SUCCESS'
                                ? res?.dealCode
                                : '',
                        Status: res?.status
                        // Channel: channel ? channel : 'Direct'
                    });
                } else {
                    window?.webengage?.track('DealClicked', {
                        OfferName: `${data?.title}`,
                        RedemptionType: `${data?.redemptionType}`,
                        CashbackPercentage: `${data?.eligibleCashback}`,
                        CouponCode: `${data?.redemptionCode}`,
                        Category: `${data?.category}`,
                        Vendor: `${data?.vendorName}`,
                        Link: `${data?.url}`,
                        EndDate: `${data?.endDate}`,
                        Tags: `${data?.tags}`,
                        DealId: `${data?.dealId}`,
                        VoucherCode:
                            data?.redemptionType === 'VOUCHER' &&
                            res?.status === 'SUCCESS'
                                ? res?.dealCode
                                : '',
                        Status: res?.status
                        // Channel: channel ? channel : 'Direct'
                    });
                }
            })
            .catch((err) => {
                // console.log(err);
                toast.error('Something went wrong. Please try again');
            });
    };

    const handleScratchCardClick = () => {
        window?.webengage?.track('ScratchCardClicked',{
            responseID: `${ResponseID}`,
        });
    };

    useEffect(() => {
        // if (scParam && EventName) {
        //     queryParams.delete('sc');
        //     queryParams.delete('eventName');
        //     history.replace({
        //         search: queryParams.toString()
        //     });

        if (isAuthenticated && scParam === 'true' && EventName && (EventTime || ResponseID)) {
            handleScratchCardClick();
            generateScratchCard();
        }
        // }
    }, [isAuthenticated ,scParam, EventName, EventTime , ResponseID]);

    useEffect(() => {
        if (isAuthenticated) {
            getUserScratchcards();
        }
    }, [isAuthenticated]);

    useEffect(() => {
        if (isAuthenticated) {
            if (redirectUrl) {
                history.push(redirectUrl);
                dispatch(authActions.closeLoginModal());
            } else {
                history.push(location.pathname + location.search);
            }
        } else {
            if (scParam === 'true' && EventName && (EventTime || ResponseID)) {
                // console.log("under UseEffect ")
                const loginUrl = location.pathname + location.search;
                dispatch(authActions.openLoginModal(loginUrl));
            }
        }
    }, [isAuthenticated ,scParam, EventName, EventTime , ResponseID]);

    return {
        openScratchCard,
        setOpenScratchCard,
        rewardData,
        loadingSC,
        userScratchcard,
        updateScratchCardStatus,
        rewardRedeemHandler,
        setRewardData
    };
};

export default useData;
